import "core-js/modules/es6.array.find";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.assign";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import $ from 'jquery';
import wx from 'weixin-js-sdk';
import examUtils from '@/js/page/examUtil.js'; //试题解析页面

import DoQuestionBzAswer from './DoQuestionBzAswer.vue'; //教师批改页面

import DoQuestionAppraise from './DoQuestionAppraise.vue'; //多题选择题的 答题区域

import DoQuestion16 from './DoQuestion16.vue'; //拖动插件

import VueDraggableResizable from '@/components/ppt/vue-draggable-resizable.vue'; //音频播放组件

import AudioPlay from './AudioPlay.vue'; //阿里云播放器组件

import VueAliplayer from '@/components/live/VueAliplayer.vue'; //音频录制组件

import Record from '@/components/live/Record.vue'; //quill-editor

import VueQuillEditor from '@/components/quill_editor/editor.vue';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
export default {
  name: 'DoQuestion',
  props: {
    initShowType: Number,
    //学员主键
    initStuId: Number,
    //试题主键
    initQuestionId: Number,
    //学员试题的主键
    initStudentQuestionId: Number,
    //初始的试题信息
    initQuestionInfo: Object,
    // 查看页面的显示状态 0:是默认根据试卷走  1为常规类型清除页面的样式设置
    initLookType: {
      type: Number,
      default: 0
    },
    //初始的学员做题的信息
    value: {
      type: Object,
      default: function _default() {
        return {
          eqOption: "",
          eqAnswer: "",
          GET_SCORE: "",
          getScoreIfChange: 0,
          childStuAnswerList: []
        };
      }
    },
    //学员试卷主键
    studentExamPaperId: Number,
    //项目ID
    initProId: String,
    //传递的学员试题的对象信息
    initTablePageInfo: Object,
    //如果是阅读题子题的话 试题的分数
    initEqScore: Number,
    //是否显示操作行(交卷 取消) 0：不显示按钮  1:单独做题页面(交卷 取消)  2:试卷中的做题页面(按道显示)
    ifOperaRow: {
      type: Number,
      default: 1
    },
    //是否显示标准答案及解析 0：不显示  1:显示标准答案及解析   暂时废除 使用showType判断
    ifShowAppraise: {
      type: Number,
      default: 0
    },
    //第几块
    blockIndex: {
      type: Number,
      default: 0
    },
    //第几道题
    questionIndex: {
      type: Number,
      default: 0
    },
    //试卷中总共有几道题
    maxIndex: {
      type: Number,
      default: 1
    },
    parentCssSet: {
      type: Object,
      default: null
    },
    heightChild: {
      type: Number,
      default: null
    },
    //是否是子题
    ifChild: {
      type: Number,
      default: 0
    },
    //是否显示题型和序号
    ifShowType: {
      type: Number,
      default: 1
    }
  },
  components: {
    DoQuestionBzAswer: DoQuestionBzAswer,
    DoQuestionAppraise: DoQuestionAppraise,
    VueDraggableResizable: VueDraggableResizable,
    AudioPlay: AudioPlay,
    DoQuestion16: DoQuestion16,
    "ali-player": VueAliplayer,
    Record: Record,
    "quill-editor": VueQuillEditor
  },
  data: function data() {
    return {
      //学员主键
      stuId: 0,
      //试题主键
      questionId: 0,
      //学员试题的主键
      studentQuestionId: 0,
      //项目ID
      proId: "",
      //试题显示类型 添加:0  修改页面:1  预览页面:2   做题页面:3  批改页面:4  结果查看页面:5
      showType: 3,
      //是否已经加载完 加载完成后才显示解析和批改等信息
      isLoading: false,
      //是否打开附件页面
      openFileFlag: false,
      //是否显示试题页面
      openQuestionFlag: true,
      //是否打开前置页面
      openPrevFlag: false,
      //子题的 题目内容 不默认显示时 显示 按钮
      openScript: false,
      //子题有单独的题目附件时 显示按钮
      openPlayTalk: false,
      //当前打开的第几个前置页面
      openPrevIndex: -1,
      ///////////////////////////////////////////////////////////
      //区分单页面显示附件(新定义，添加 可修改)
      newPlayerWay: false,
      gridProportion: 24,
      //是否显示头部返回
      hearingButton: true,
      //是否显示浮窗试题
      showQuestions: false,
      ///////////////////////////////////////////////////////////
      //是否播放题目音频
      eqContentVolumeFlag: false,
      //如果是阅读题 当前显示的是第几题
      nowCheckQuestion: -1,
      //试题信息 包含题型等各种信息
      questionInfo: {
        eqOption: []
      },
      //做题信息
      doQuestionInfo: {
        eqOption: "",
        eqAnswer: "",
        GET_SCORE: "",
        getScoreIfChange: 0
      },
      //保存按钮的状态
      fullscreenLoading: false,
      //学员试题的接口页面的配置信息
      //百利考试 学员试题的接口页面的配置信息
      tablePageInfo: {
        tableId: 17976,
        addPageId: 11651,
        updatePageId: 11658
      },
      //crm 学员试题的接口页面的配置信息
      //tablePageInfo:{ tableId:142,  addPageId:773, updatePageId:774 },
      //传递给子题的样式设置
      childCssSet: {},

      /**
       * 编辑器的内容样式
       */
      editorOption: {
        theme: 'bubble',
        placeholder: "",
        modules: {
          toolbar: [['bold', 'italic'], [{
            'list': 'ordered'
          }, {
            'list': 'bullet'
          }]]
        }
      },

      /**
       * 填空题输入框内容
       */
      editorText: {
        theme: 'bubble',
        placeholder: "",
        modules: {}
      },
      // [
      //       ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
      //       ["blockquote", "code-block"], // 引用  代码块
      //       [{ header: 1 }, { header: 2 }], // 1、2 级标题
      //       [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表
      //       [{ script: "sub" }, { script: "super" }], // 上标/下标
      //       [{ indent: "-1" }, { indent: "+1" }], // 缩进
      //       // [{'direction': 'rtl'}],                         // 文本方向
      //       // [{ size: ["small", false, "large", "huge"] }], // 字体大小
      //       // [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
      //       [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
      //       // [{ font: [] }], // 字体种类
      //       [{ align: [] }], // 对齐方式
      //       ["clean"] // 清除文本格式
      //       //["link", "image", "video"]  链接、图片、视频
      //     ]

      /**
       * 长难句的选项类型
       */
      cnjAnswerType: [{
        DIC_ID: 1,
        DIC_NAME: '主语',
        btnName: '主语',
        fnHandler: 'addCnjEqOption'
      }, {
        DIC_ID: 2,
        DIC_NAME: '谓语',
        btnName: '谓语',
        fnHandler: 'addCnjEqOption'
      }, {
        DIC_ID: 3,
        DIC_NAME: '宾语',
        btnName: '宾语',
        fnHandler: 'addCnjEqOption'
      }, {
        DIC_ID: 4,
        DIC_NAME: '定语',
        btnName: '定语',
        fnHandler: 'addCnjEqOption'
      }, {
        DIC_ID: 5,
        DIC_NAME: '状语',
        btnName: '状语',
        fnHandler: 'addCnjEqOption'
      }, {
        DIC_ID: 6,
        DIC_NAME: '补语',
        btnName: '补语',
        fnHandler: 'addCnjEqOption'
      }, {
        DIC_ID: 7,
        DIC_NAME: '形容词及其词组',
        btnName: '形容词及其词组',
        fnHandler: 'addCnjEqOption'
      }, {
        DIC_ID: 8,
        DIC_NAME: '副词及其词组',
        btnName: '副词及其词组',
        fnHandler: 'addCnjEqOption'
      }, {
        DIC_ID: 9,
        DIC_NAME: '非谓语动词',
        btnName: '非谓语动词',
        fnHandler: 'addCnjEqOption'
      }, {
        DIC_ID: 10,
        DIC_NAME: '介词短语',
        btnName: '介词短语',
        fnHandler: 'addCnjEqOption'
      }],
      eqTypeMap: {
        DIC_NAME_1: '单选题',
        DIC_NAME_2: '多选题',
        DIC_NAME_3: '判断题',
        DIC_NAME_4: '填空题',
        DIC_NAME_7: '简答题',
        DIC_NAME_8: '选择填空题',
        DIC_NAME_9: '阅读题',
        DIC_NAME_10: '匹配题',
        DIC_NAME_14: '长难句',
        DIC_NAME_15: '插入填空'
      },
      zmArr: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"],
      screenHeight: '',
      ind: 0,
      beginNing: 'Beginning',
      centerDialogVisible: false,
      //纠错
      errorCorrection: '',
      //纠错信息
      errorCorrectionOptions: [{
        value: 1,
        label: '题目内容错误'
      }, {
        value: 2,
        label: '格式错误'
      }, {
        value: 3,
        label: '答案错误'
      }, {
        value: 4,
        label: '其他错误'
      }],
      errorCorrectionSelect: 1,
      countHeight: 0,
      writingTitleHide: 0,
      writingTips: 0,
      WordCount: 0 //写作计算数字和单词个数

    };
  },
  watch: {
    screenHeight: function screenHeight() {
      //如果clientHeight 发生改变，这个函数就会运行
      return this.screenHeight;
    }
  },
  directives: {
    drag: function drag(el) {
      var dragBox = el; //获取当前元素

      dragBox.onmousedown = function (e) {
        //算出鼠标相对元素的位置
        var disX = e.clientX - dragBox.offsetLeft;
        var disY = e.clientY - dragBox.offsetTop;

        document.onmousemove = function (e) {
          //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
          var left = e.clientX - disX;
          var top = e.clientY - disY; //移动当前元素

          dragBox.style.left = left + "px";
          dragBox.style.top = top + "px";
        };

        document.onmouseup = function (e) {
          //鼠标弹起来的时候不再移动
          document.onmousemove = null; //预防鼠标弹起来后还会循环（即预防鼠标放上去的时候还会移动）

          document.onmouseup = null;
        };
      };
    }
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {
    var _this = this;

    if (this.heightChild && this.heightChild == 1) {
      this.countHeight = 30;
    } else {
      this.countHeight = 0;
    }

    this.screenHeight = document.body.clientHeight;

    window.onresize = function () {
      return function () {
        _this.screenHeight = document.body.clientHeight;
      }();
    };

    var that = this; //请求地址传递的参数

    var paramsJson = this.$route.params; //判断是否有初始的试题显示类型 如果有则赋值给showType

    if (that.initShowType) {
      that.showType = that.initShowType;
    } else if (paramsJson.initShowType) {
      that.showType = paramsJson.initShowType;
    } //学员主键


    if (that.initStuId) {
      that.stuId = that.initStuId;
    } else if (paramsJson.initStuId) {
      that.stuId = paramsJson.initStuId;
    } //试题主键


    if (that.initQuestionId) {
      that.questionId = that.initQuestionId;
    } else if (paramsJson.initQuestionId) {
      that.questionId = paramsJson.initQuestionId;
    } //学员试题的主键


    if (that.initStudentQuestionId) {
      that.studentQuestionId = that.initStudentQuestionId;
    } else if (paramsJson.initStudentQuestionId) {
      that.studentQuestionId = paramsJson.initStudentQuestionId;
    } //项目ID


    if (paramsJson.initProId) {
      that.proId = paramsJson.initProId;
    }

    that.getSysSet();
  },
  methods: {
    /**
     * 计算Quill-Editor内单词和数字个数  以空格和特殊字符区分的为独立的两个内容计入计算内容
    */
    onEditorChange: function onEditorChange(e) {
      console.log("e=====================", e);
      this.editorWordCount(e.text);
    },
    editorWordCount: function editorWordCount(text) {
      var Array = text.split(/[`~!@#$^&*()=|{}':;',\\\[\]\.<_>\/?~！@#￥……&*（）——|{}【】'；：""'。，、？\s]/); // var Array = text.split('')

      Array = Array.filter(function (s) {
        // s = s.replace(/[`~!@#$^&*()=|{}':;',\\\[\]\.<_>\/?~！@#￥……&*（）——|{}【】'；：""'。，、？]/,'');
        return s && s.trim();
      });
      console.log("Array.length=======================", Array.length);
      this.WordCount = Array.length;
    },

    /**
     * 阅读滑动
     */
    handleScroll: function handleScroll() {
      var div = this.$refs.box;

      if (div.scrollTop == 0) {
        this.beginNing = 'Beginning';
      }

      if (div.scrollHeight / 3 < div.scrollTop) {
        this.beginNing = 'More Available';
      }

      if (div.offsetHeight + div.scrollTop - div.scrollHeight >= -1) {
        this.beginNing = 'End';
        console.log('到底了'); // 切换按钮显示状态

        this.$emit("changeQuestionStateLook", {
          "continueDisabled": false
        });
      }
    },

    /**
     * 显示浮窗试题
     */
    showTestQuestions: function showTestQuestions() {
      this.showQuestions = true;
    },

    /**
     * 关闭浮窗试题
     */
    closeTestQuestions: function closeTestQuestions() {
      this.showQuestions = false;
    },

    /**
     * 跳转至说明页
     */
    goDescription: function goDescription(index) {
      this.ind = index;
      this.openQuestionFlag = false;
      this.hearingButton = false;
    },
    goColumn: function goColumn(index) {
      this.goReturn();
      var that = this; //进入下一道题

      that.getQuestionShowType(index);
    },

    /**
     * 返回
     */
    goReturn: function goReturn(index) {
      this.openQuestionFlag = true;
      this.hearingButton = true;
    },
    nullFunction: function nullFunction() {},

    /**
     * 获取系统设置信息
     */
    getSysSet: function getSysSet() {
      var that = this; //        console.log("that.initTablePageInfo================",that.initTablePageInfo);

      if (that.initTablePageInfo) {
        that.tablePageInfo = that.initTablePageInfo;
        that.zdyMounted();
      } else {
        var url = "/model_getSysSet.do";
        var toHtData = {};
        toHtData.tableName = "XCX_SYS_SET";
        toHtData.proId = that.proId;
        this.$axios.post(url, toHtData).then(function (res) {
          if (res.data) {
            var sysSetInfo = res.data.XCX_SYS_SET;
            var tablePageInfo = {};
            tablePageInfo.tableId = sysSetInfo.DOQUESTION_TABLE;
            tablePageInfo.addPageId = sysSetInfo.DOQUESTION_ADD_PAGE;
            tablePageInfo.updatePageId = sysSetInfo.DOQUESTION_UPDATE_PAGE;
            that.tablePageInfo = tablePageInfo;
            that.zdyMounted();
          } else {
            alert("没有获取到题库相关设置信息,请联系管理员");
          }
        }).catch(function (error) {
          console.log("=====" + error);
          alert("没有获取到题库相关设置信息,请联系管理员");
        });
      }
    },
    zdyMounted: function zdyMounted() {
      var that = this; //判断是否有试题信息 如果有赋值给questionInfo  如果没有则进行后台试题信息的加载

      if (that.initQuestionInfo) {
        that.questionInfo = that.initQuestionInfo;
        that.initUpdateQuestion();
        console.log("questionInfo===========", this.questionInfo);
      } else if (that.questionId > 0) {
        //去后台请求本道试题的信息
        that.getQuestionInfo();
      } else {
        that.showType = 3;
      }
    },

    /**
     * 试题加载后进行初始化
     */
    initUpdateQuestion: function initUpdateQuestion() {
      var that = this;

      if (!that.value.eqAnswer) {
        this.$set(that.value, "eqAnswer", "");
      }

      if (!that.value.eqOption) {
        this.value.eqOption = "";
      }

      if (!that.value.GET_SCORE) {
        this.value.GET_SCORE = "";
      } //如果是填空题设置为数组


      if (that.questionInfo.eqType == 4 || that.questionInfo.eqType == 2 || that.questionInfo.eqType == 10) {
        if (that.value && that.value.eqAnswer == "") {
          that.value.eqAnswer = [];
        }
      } else if (that.questionInfo.eqType == 14) {
        //长难句试题设置为数组
        if (that.value && that.value.eqAnswer == "") {
          if (that.value.eqAnswer == "") {
            that.value.eqAnswer = [];
          }

          if (that.value.eqAnswer1 == "") {
            that.value.eqAnswer1 = [];
          }

          if (that.value.eqOption == "") {
            that.value.eqOption = [];
          }
        }
      } else if (that.questionInfo.eqType == 8) {
        if (that.value && that.value.eqAnswer == "") {
          this.$set(that.value, "eqAnswer", []); //that.value.eqAnswer1 = [];
        }
      } else if (that.questionInfo.eqType == 7) {
        //阅读题
        if (that.value && !that.value.eqAnswerFile) {
          this.$set(that.value, "eqAnswerFile", []);
        }
      } else if (that.questionInfo.eqType == 9) {
        var childQuestionInfoList = that.questionInfo.childQuestionInfoList;

        if (!that.value.eqAnswer) {
          var eqAnswerList = [];
          childQuestionInfoList.forEach(function (element, index) {
            eqAnswerList.push();
          });
          this.$set(that.value, "eqAnswer", eqAnswerList);
        }

        if (!that.value.childStuAnswerList) {
          var childStuAnswerList = [];
          childQuestionInfoList.forEach(function (element, index) {
            childStuAnswerList.push({});
          });
          this.$set(that.value, "childStuAnswerList", childStuAnswerList);
        }
      } else if (that.questionInfo.eqType == 16) {
        //多题选择
        if (that.value && !that.value.eqAnswer) {
          var eqAnswerArr = [];
          that.questionInfo.eqOtherInfo_16.forEach(function (element, index) {
            eqAnswerArr.push([]);
          });
          this.$set(that.value, "eqAnswer", eqAnswerArr);
        } else {
          var eqAnswerNew = [];
          that.value.eqAnswer.forEach(function (element, index) {
            if (typeof element == "string") {
              eqAnswerNew.push(element.split(","));
            } else {
              eqAnswerNew.push([]);
            }
          });
          that.value.eqAnswer = eqAnswerNew;
        }
      }

      if (that.initEqScore > 0) {
        that.questionInfo.eqScore = that.initEqScore;
      } //判断试题内容是否是不显示的 如果是


      if (this.ifChild == 0) {
        if (that.questionInfo.prevSet && that.questionInfo.prevSet.eqContentIfOnlyFile == 2) {
          this.openScript = true;
        } else {
          this.openScript = false;
        }

        this.$emit("changeQuestionState", {
          "openPrevFlag": this.openPrevFlag,
          "openFileFlag": this.openFileFlag,
          "openQuestionFlag": this.openQuestionFlag,
          "openScript": this.openScript,
          "openPlayTalk": null
        });
      } //进行试题是否已做的判断


      var quesEqType = that.questionInfo.eqType; //单选，多选，判断，填空，匹配、长难句

      if (quesEqType == 1 || quesEqType == 2 || quesEqType == 3 || quesEqType == 4 || quesEqType == 10 || quesEqType == 14) {
        that.blankChange();
      } else if (quesEqType == 7) {
        //简答
        that.discussChange(); // 进行字数计算

        if (that.value.eqAnswer) {
          try {
            that.editorWordCount(that.value.eqAnswer);
          } catch (err) {
            console.log("初始化时,编辑器字符个数计算出错!");
          }
        }
      } //判断是否有前置页面并进行显示


      if (this.showType == 3 && !(that.questionInfo.initChildIndex > 0)) {
        this.openPrevSet();
      } //判断试题是否为每次一道 如果是


      if (that.questionInfo.ZD_DO_WAY == 1 && this.openQuestionFlag && quesEqType == 9) {
        that.$nextTick(function () {
          if (that.questionInfo.initChildIndex) {
            that.showQuestionIndex(that.questionInfo.initChildIndex);
          } else {
            that.getQuestionShowType(0);
          }
        });
      }

      if (that.parentCssSet) {
        if (that.questionInfo.cssSet) {
          that.questionInfo.cssSet.cssType = that.parentCssSet.cssType;
        } else {
          that.questionInfo.cssSet = {
            cssType: that.parentCssSet.cssType
          };
        }
      } else if (!that.questionInfo.cssSet) {
        that.questionInfo.cssSet = {
          cssType: 1,
          //样式表设置
          flexType: 1,
          //题目和试题结构设置
          dtkSet: 1,
          //答题卡设置
          czlPosition: 1 //操作栏位置

        };
      }

      if (that.initLookType == 1) {
        that.questionInfo.cssSet = {
          cssType: 1,
          //样式表设置
          flexType: 1,
          //题目和试题结构设置
          dtkSet: 1,
          //答题卡设置
          czlPosition: 1 //操作栏位置

        };
        that.questionInfo.ZD_DO_WAY = 0;
      } //需要传递给子试题的样式设置


      that.childCssSet = {
        cssType: that.questionInfo.cssSet.cssType,
        flexType: 1
      };

      if (!that.questionInfo.prevSet) {
        that.questionInfo.prevSet = {
          cssType: 1,
          flexType: 1
        };
      }

      if (that.questionInfo.eqType == 7) {
        that.writingTitleHide = 34;
      }

      if (this.showType == 3 && this.questionInfo.eqRemark) {
        this.writingTips = 100; //          console.log(this.showType,'------------*************this.showType****************---------')
      } //        根据条件划分结构


      if (!that.questionInfo.prevSet.eqContentIfOnlyFile || that.questionInfo.prevSet.eqContentIfOnlyFile != 2) {
        that.gridProportion = 24;
      } //        console.log("that.questionInfo.cssSet============================",that.questionInfo.cssSet);
      //每次一道是才左右结构 先去除掉 否则常规的阅读题的左右显示不对 &&that.questionInfo.ZD_DO_WAY == 1


      if (that.questionInfo.cssSet.flexType == 2 || that.questionInfo.cssSet.flexType == 3) {
        that.gridProportion = 12;
      } //        if(that.questionInfo.eqType==8){
      //          that.gridProportion = 0
      //
      //        }


      this.isLoading = true;
      that.$nextTick(function () {
        try {
          console.log("------------------handleScroll--------");
          that.handleScroll();
        } catch (e) {}
      });
    },

    /**
     * 判断是否有前置页面 如果有则打开前置页面
     */
    openPrevSet: function openPrevSet() {
      var that = this;
      var prevSet = this.questionInfo.prevSet;

      if (prevSet && prevSet.ifShow == 1 && prevSet.prevPageArr && prevSet.prevPageArr.length > 0) {
        this.openPrevFlag = true;
        this.openPrevIndex = 0;
        this.openQuestionFlag = false;
        var continueDisabled = false;

        if (prevSet.prevPageArr[0].ifLook == 1) {
          continueDisabled = true;
        } //切换试卷页面的 按钮的显示状态


        this.$emit("changeQuestionState", {
          "openPrevFlag": this.openPrevFlag,
          "openFileFlag": this.openFileFlag,
          "openQuestionFlag": this.openQuestionFlag,
          "openScript": null,
          "openPlayTalk": null,
          "continueDisabled": continueDisabled
        });
        var limitTime = this.questionInfo.prevSet.prevPageArr[0].limitTime;

        if (!limitTime) {
          limitTime = 0;
        }

        this.$emit("setCountDownInfo", 2, limitTime);
      } else {
        //如果获取试题的附件信息 判断是否单独显示附件音频播放页面
        this.openDlContentFile();
      }
    },

    /**
     * 判断是否有单独页面的附件信息 如果有则打开附件播放页面
     */
    openDlContentFile: function openDlContentFile() {
      var eqContentFile = this.questionInfo.eqContentFile;

      if (eqContentFile) {
        var prevFileInfo = [];
        var newContentFile = [];
        eqContentFile.forEach(function (element, index) {
          //播放器形式 如果是单独页面
          var playerWay = element.playerWay;

          if (playerWay == 1) {
            prevFileInfo.push(element);
          } else {
            newContentFile.push(element);
          }
        });

        if (prevFileInfo.length > 0) {
          //是否打开附件页面
          this.openFileFlag = true;
          this.openQuestionFlag = false;
          this.questionInfo.prevFileInfo = prevFileInfo;

          if (this.ifChild == 0) {
            this.openPlayTalk = true;
          }
        } else {
          if (this.ifChild == 0) {
            this.openPlayTalk = false;
          } else {
            this.openPlayTalk = null;
          } //试题加载时判断是否有题目录音 进行播放
          //this.playEqContentVolume();


          this.showQuestionInfo();
        } //          console.log("newContentFile================",newContentFile);


        this.questionInfo.eqContentFile = newContentFile;
        this.$emit("changeQuestionState", {
          "openPrevFlag": this.openPrevFlag,
          "openFileFlag": this.openFileFlag,
          "openQuestionFlag": this.openQuestionFlag,
          "openScript": null,
          "openPlayTalk": this.openPlayTalk
        });
      } else {
        //试题加载时判断是否有题目录音 进行播放
        //this.playEqContentVolume();
        this.showQuestionInfo();
      }
    },

    /**
     * 进入前置页面的下一页
     */
    nextPrevPage: function nextPrevPage() {
      this.openPrevIndex++;
      var prevSet = this.questionInfo.prevSet;

      if (this.questionInfo.eqType == 9 && this.nowCheckQuestion >= 0 && this.$refs["child_question_" + this.questionId + "_" + this.nowCheckQuestion]) {
        console.log("========111===============", this.questionId, this.nowCheckQuestion);
        console.log("========222===============", this.$refs["child_question_" + this.questionId + "_" + this.nowCheckQuestion]);
        var oneQuestionRef = this.$refs["child_question_" + this.questionId + "_" + this.nowCheckQuestion][0];
        oneQuestionRef.nextPrevPage();
      } else {
        console.log("this.questionInfo===========================", this.questionInfo);
        console.log("prevSet===========================", prevSet, this.openPrevIndex, this.openPrevIndex >= prevSet.prevPageArr.length || !prevSet.prevPageArr);

        if (this.openPrevIndex >= prevSet.prevPageArr.length || !prevSet.prevPageArr) {
          this.openPrevFlag = false;
          this.openPrevIndex = -1;
          this.openQuestionFlag = true;
          this.questionInfo.prevSet.prevPageArr = []; //如果获取试题的附件信息 判断是否单独显示附件音频播放页面

          this.openDlContentFile();
        } else {
          var limitTime = prevSet.prevPageArr[this.openPrevIndex].limitTime;

          if (!limitTime) {
            limitTime = 0;
          }

          this.$emit("setCountDownInfo", 2, limitTime);
        }

        console.log("按钮状态===========================", this.openPrevFlag, this.openFileFlag, this.openQuestionFlag); //切换试卷页面的 按钮的显示状态

        this.$emit("changeQuestionState", {
          "openPrevFlag": this.openPrevFlag,
          "openFileFlag": this.openFileFlag,
          "openQuestionFlag": this.openQuestionFlag,
          "openScript": null,
          "openPlayTalk": null
        });
      }
    },

    /**
     * 去后台请求试题信息
     */
    getQuestionInfo: function getQuestionInfo() {
      var that = this; //根据试题主键 questionId

      var questionId = this.questionId;
      var studentQuestionId = this.studentQuestionId;
      var url = "/vueQuestion_getQuestionInfo.do";
      var toHtData = {};
      toHtData.questionId = questionId;
      toHtData.proId = that.proId;
      toHtData.studentQuestionId = studentQuestionId;
      this.$axios.post(url, toHtData).then(function (res) {
        if (res.data) {
          that.questionInfo = res.data.question;

          if (res.data.studentQuestionInfo) {
            that.value = res.data.studentQuestionInfo;
          }

          that.initUpdateQuestion();
        } else {
          //没有获取到试题信息 可以新增试题
          that.showType = 3;
          that.$message({
            showClose: true,
            message: "没有获取到试题信息 可以新增试题",
            type: 'error'
          });
        }
      }).catch(function (error) {
        console.log("=====" + error);
      });
    },

    /**
     * 获取作答信息
     */
    getDoQuestion: function getDoQuestion() {
      //根据试题主键 questionId
      var questionId = this.questionId;
      var questionInfo = this.questionInfo; //试题类型

      var eqType = questionInfo.eqType; //学员试题主键

      var studentQuestionId = this.studentQuestionId; //学员主键

      var stuId = this.stuId; //学员试卷主键

      var studentExamPaperId = this.studentExamPaperId;
      var toHtData = {};
      toHtData.eqType = eqType;
      toHtData.STUDENT_EXAM_PAPER = studentExamPaperId;
      toHtData.STU_ID = stuId;

      if (studentExamPaperId > 0) {
        //试卷来源
        toHtData.ZD_SOURCE = 1;
      } else {
        //错题重做
        toHtData.ZD_SOURCE = 2;
      }

      toHtData.QUESTION_ID = questionId;
      toHtData.studentQuestionId = studentQuestionId;
      toHtData.mainDataId = studentQuestionId; //获取做题的结果信息
      //获取做题的结果信息

      var doQuestionInfo = this.value; //获取试题的作答答案信息

      var toHtDataAnwer = examUtils.getDoQuestionAnwerInfo(questionInfo, doQuestionInfo);
      toHtData = Object.assign(toHtData, toHtDataAnwer);
      return toHtData;
    },

    /**
     * 保存试题
     */
    saveDoQuestion: function saveDoQuestion() {
      var _this2 = this;

      //判断是做题还是批改功能
      var that = this; //学员试题主键

      var studentQuestionId = this.studentQuestionId;
      var showType = this.showType;
      var toHtData = this.getDoQuestion();
      var url = "/vueQuestion_doQuestion.do";
      console.log(this.loginForm);
      this.fullscreenLoading = true;
      toHtData.showType = showType;
      toHtData.tableId = this.tablePageInfo.tableId; //学员试题主键存在则 进行修改功能 不存在则进行添加功能

      if (studentQuestionId > 0) {
        toHtData.pageId = this.tablePageInfo.updatePageId;
      } else {
        toHtData.pageId = this.tablePageInfo.addPageId;
      }

      toHtData.isInterFace = 1;
      this.$axios.post(url, toHtData).then(function (res) {
        that.fullscreenLoading = false;

        if (res.data > 0) {
          // 单独的做题页面
          if (that.ifOperaRow == 1) {
            var confirmContent = "交卷成功!查看客观题结果";

            if (that.showType == 4) {
              confirmContent = "批改试题成功!";
            }

            if (!studentQuestionId > 0) {
              that.studentQuestionId = res.data;
            }

            that.showType = 5;
            that.$confirm(confirmContent, '提示', {
              confirmButtonText: '查看',
              cancelButtonText: '关闭',
              customClass: 'comfirm_zdy',
              type: 'warning'
            }).then(function () {
              that.getQuestionInfo();
            }).catch(function () {
              that.cancelPage();
            });
          } else if (that.ifOperaRow == 0) {
            // 试卷中的下一题
            _this2.$emit("updateStudentQuestionId", that.questionIndex, that.studentQuestionId > 0 ? that.studentQuestionId : res.data, that.value);
          }
        } else {
          that.$message({
            showClose: true,
            message: "保存失败,请重试!",
            type: 'error'
          });
        }
      }).catch(function (error) {
        console.log("=====" + error);
      });
    },

    /**
     * 录制音频结束时 进行答案附件的绑定
     * 学生做题上传录音
     */
    setEqAnswerFile: function setEqAnswerFile(audioSrc) {
      this.value.eqAnswerFile = audioSrc;
      this.discussChange(audioSrc);
    },

    /**
     * 计算阅读题的得分 根据子题的得分
     */
    ydScoreChange: function ydScoreChange() {
      var _this3 = this;

      var questionId = this.questionId;
      var childQuestionArr = this.questionInfo.childQuestionArr;
      var ycScore = 0;

      if (childQuestionArr) {
        childQuestionArr.forEach(function (element, questionIndex) {
          var oneQuestionRef = _this3.$refs["child_question_" + questionId + "_" + questionIndex][0];
          var getScore = oneQuestionRef.value.GET_SCORE * 1;
          ycScore += getScore;
        });
      }

      this.value.GET_SCORE = ycScore;
    },

    /**
     * 得分改变时 如果是阅读题的子题 则进行阅读题分数改变的触发
     */
    getScoreChange: function getScoreChange() {
      this.$emit("ydScoreChange");
    },

    /**
     * 添加一个选项题的选项
     */
    clickAddEqOption: function clickAddEqOption() {
      var doQuestionInfo = this.value;

      if (!doQuestionInfo.eqOption) {
        doQuestionInfo.eqOption = [];
      }

      doQuestionInfo.eqOption.push("");

      if (!doQuestionInfo.eqAnswer) {
        doQuestionInfo.eqAnswer = [];
      }

      doQuestionInfo.eqAnswer.push("");

      if (!doQuestionInfo.eqAnswer1) {
        doQuestionInfo.eqAnswer1 = [];
      }

      doQuestionInfo.eqAnswer1.push("");
      this.blankChange(); //添加选项时，切换试题选项卡的状态
    },

    /**
     * 删除一个选项
     */
    clickDeleteEqOption: function clickDeleteEqOption(index) {
      var questionInfo = this.questionInfo;
      var doQuestionInfo = this.value;
      doQuestionInfo.eqOption.splice(index, 1); //如果是长难句

      if (questionInfo.eqType == 14) {
        doQuestionInfo.eqAnswer.splice(index, 1);
        doQuestionInfo.eqAnswer1.splice(index, 1);
      }
    },

    /**
     * 选中时 获取选中内容
     */
    eqContentSelect: function eqContentSelect(event) {
      var questionInfo = this.questionInfo;
      var doQuestionInfo = this.value; //        console.log("右键事件！！！");

      if (questionInfo.eqType == 14) {
        //获取选中的文字 进行答案的增加
        event.preventDefault();
        var nowCheckText = this.GetSelectedText(); //          console.log("nowCheckText======",nowCheckText);

        if (nowCheckText) {
          if (!doQuestionInfo.eqOption) {
            doQuestionInfo.eqOption = [];
          }

          doQuestionInfo.eqOption.push("");

          if (!doQuestionInfo.eqAnswer) {
            doQuestionInfo.eqAnswer = [];
          }

          doQuestionInfo.eqAnswer.push(nowCheckText);

          if (!doQuestionInfo.eqAnswer1) {
            doQuestionInfo.eqAnswer1 = [];
          }

          doQuestionInfo.eqAnswer1.push("");
        } else {
          that.$message({
            showClose: true,
            message: "请选中内容后，点击鼠标右键",
            type: 'error'
          });
        }
      }
    },

    /**
     * 获取当前选中的内容
     */
    GetSelectedText: function GetSelectedText() {
      var selText = "";

      if (window.getSelection) {
        // all browsers, except IE before version 9
        if (document.activeElement && (document.activeElement.tagName.toLowerCase() == "textarea" || document.activeElement.tagName.toLowerCase() == "input")) {
          var text = document.activeElement.value;
          selText = text.substring(document.activeElement.selectionStart, document.activeElement.selectionEnd);
        } else {
          var selRange = window.getSelection();
          selText = selRange.toString();
        }
      } else {
        if (document.selection.createRange) {
          // Internet Explorer
          var range = document.selection.createRange();
          selText = range.text;
        }
      }

      return selText;
    },

    /**
     * 单选/判断题答案选中时 切换答题卡的状态
     */

    /*radioChange() {
     this.$emit("updateDtkState",this.questionIndex,true);
     },*/

    /**
     * 单选题/多选题/判断题/填空题填写完成时，切换答题卡的状态
     */
    blankChange: function blankChange() {
      var blankFlag = false; //选项答案

      var doQuestionInfoArr = this.value.eqAnswer;
      var eqOptionLen = this.questionInfo.eqOption.length; //试题选项个数

      var doQuestionInfoLen = doQuestionInfoArr.length; //试题答案个数

      var eqType = this.questionInfo.eqType; //试题题型

      if (eqType == 4 || eqType == 10) {
        //填空题、匹配题
        //判断答案个数和选项个数是否相同，长度不同为未答题，长度相同则循环判断
        if (doQuestionInfoLen != eqOptionLen) {
          blankFlag = false;
        } else {
          for (var i = 0; i < doQuestionInfoLen; i++) {
            if (doQuestionInfoArr[i] == "" || doQuestionInfoArr[i] == null) {
              blankFlag = false;
              break;
            } else {
              blankFlag = true;
            }
          }
        }
      } else if (eqType == 1 || eqType == 2 || eqType == 3) {
        //单选题、多选题、判断题
        if (doQuestionInfoLen > 0) {
          blankFlag = true;
        } else {
          blankFlag = false;
        }
      } else if (eqType == 14) {
        //长难句
        //下拉框和文本框都有值，切换试题选项卡的状态为“已答题”
        var optionFlag = false;
        var answerFlag = false;
        var doQuesOptionLen = this.value.eqOption.length;
        var doQuesOptionArr = this.value.eqOption; //文本框

        for (var i = 0; i < doQuestionInfoLen; i++) {
          if (doQuestionInfoArr[i] == "" || doQuestionInfoArr[i] == null) {
            optionFlag = false;
            break;
          } else {
            optionFlag = true;
          }
        } //下拉框


        for (var i = 0; i < doQuesOptionLen; i++) {
          if (doQuesOptionArr[i] == "" || doQuesOptionArr[i] == null) {
            answerFlag = false;
            break;
          } else {
            answerFlag = true;
          }
        }

        if (optionFlag && answerFlag) {
          blankFlag = true;
        } else {
          blankFlag = false;
        }
      } //        console.log("blankFlag=========",blankFlag);


      this.$emit("updateDtkState", this.questionIndex, blankFlag, null, this.blockIndex); //      window.scroll(0,0);

      setTimeout(function () {
        var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
        window.scrollTo(0, Math.max(scrollHeight - 1, 0));
      }, 100);
    },

    /**
     * 简答题(答案有音频，无音频)完成时 切换答题卡的状态
     */
    discussChange: function discussChange() {
      var blankFlag = false;
      var doQuestionInfo = this.value; //判断有无文字答案，或录制音频文件

      if ((doQuestionInfo.eqAnswer == "" || doQuestionInfo.eqAnswer == null) && (doQuestionInfo.eqAnswerFile == "" || doQuestionInfo.eqAnswerFile == null)) {
        blankFlag = false;
      } else {
        blankFlag = true;
      }

      this.$emit("updateDtkState", this.questionIndex, blankFlag, null, this.blockIndex); //      window.scroll(0,0);

      setTimeout(function () {
        var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
        window.scrollTo(0, Math.max(scrollHeight - 1, 0));
      }, 100);
    },

    /**
     * 阅读题子题 做题时 修改阅读题子题的作答状态
     */
    updateDtkState: function updateDtkState(questionIndex, ifDo) {
      if (this.questionInfo.childQuestionIfDoArr == undefined) {
        this.questionInfo.childQuestionIfDoArr = [];
      }

      var childQuestionIfDoArr = this.questionInfo.childQuestionIfDoArr;
      childQuestionIfDoArr[questionIndex] = ifDo; //阅读的子题是否全部做了 如果全部做了
      // if(this.questionInfo.childQuestionArr.length == childQuestionIfDoArr.length) {
      //   var ydIfDo = true;
      //   for (var i = 0; i < this.questionInfo.childQuestionIfDoArr.length; i++) {
      //     if(ydIfDo) {
      //       if(!childQuestionIfDoArr[i]) {
      //         ydIfDo = false;
      //       }
      //     }
      //   }
      // }

      this.$emit("updateDtkState", this.questionIndex, ifDo, questionIndex);
    },

    /**
     * 根据文件名称获取文件类型
     */
    getFileTypeByName: function getFileTypeByName(name) {
      var fileType = 'image';

      if (name.indexOf(".jpg") > 0 || name.indexOf(".png") > 0) {
        fileType = "image";
      } else if (name.indexOf(".mp4") > 0 || name.indexOf(".m3u8") > 0 || name.indexOf(".flv") > 0) {
        fileType = "video";
      } else if (name.indexOf(".mp3") > 0) {
        fileType = "audio";
      }

      return fileType;
    },

    /**
     * 文件开始上传时调用
     */
    progressFile: function progressFile(file, fileList, type) {
      this.fullscreenLoading = true;
      this.$emit("setButtonState", true); //        console.log("this.fullscreenLoading====11============",this.fullscreenLoading);
    },

    /**
     * 文件上传成功时的处理函数
     */
    successFile: function successFile(response, file, fileList, type) {
      this.fullscreenLoading = false;
      this.$emit("setButtonState", false);
      var that = this;
      var arr = response.split(":");
      var downAddress = arr[0];
      var fileId = arr[1];
      file.fileId = fileId;
      file.downAddress = downAddress;
      var toHtId = ""; //        console.log("fileList==============",fileList);

      fileList.forEach(function (element) {
        if (element.status == "success") {
          if (toHtId != "") {
            toHtId += ",";
          }

          toHtId += element.fileId;
        }

        var name = element.name;
        element.fileType = that.getFileTypeByName(name);
      });

      if (type == 0) {
        this.questionInfo.eqContentFileId = toHtId;
        this.questionInfo.eqContentFile = fileList;
      } else {
        this.value.eqAnswerFileId = toHtId;
        this.value.eqAnswerFile = fileList;
      }
    },

    /**
     * 上传失败时执行
     */
    errorFile: function errorFile(err, file, fileList, type) {
      this.fullscreenLoading = false;
      this.$emit("setButtonState", false); //        console.log("this.fullscreenLoading======22==========",this.fullscreenLoading);
    },

    /**
     * 文件删除时的处理函数
     */
    removeFile: function removeFile(file, fileList, fieldSetOne, type) {
      var that = this;
      var toHtId = "";
      fileList.forEach(function (element) {
        if (element.status == "success") {
          if (toHtId != "") {
            toHtId += ",";
          }

          toHtId += element.fileId;
        }

        var name = element.name;
        element.fileType = that.getFileTypeByName(name);
      });

      if (type == 0) {
        this.questionInfo.eqContentFileId = toHtId;
        this.questionInfo.eqContentFile = fileList;
      } else {
        this.value.eqAnswerFileId = toHtId;
        this.value.eqAnswerFile = fileList;
      }
    },

    /**
     * 文件上传个数超出时进行提醒
     */
    exceedFile: function exceedFile(files, fileList) {
      this.$message({
        message: '最大文件上传个数为:' + 5 + ",不可超出!",
        type: 'warning'
      });
    },

    /**
     * 返回上一步页面
     */
    cancelPage: function cancelPage() {
      if (this.isWeixinCient()) {
        wx.miniProgram.navigateBack({
          delta: 1
        });
      } else {
        if (document.referrer != null && document.referrer.length > 0) {
          window.location.href = document.referrer;
        } else {
          this.$router.go(-1);
        }
      }
    },
    isWeixinCient: function isWeixinCient() {
      var ua = navigator.userAgent.toLowerCase();

      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
      } else {
        return false;
      }
    },

    /**
     * 上一道
     */
    prevQuestion: function prevQuestion() {
      var that = this; //上一题如果已做 则进入试题查看页面
      //判断学员试题主键是否存在 如果存在 则nowQuestionShowType为查看(5) 否则为做题(3)

      that.getQuestionShowType(-1);
    },

    /**
     * 下一道
     */
    nextQuestion: function nextQuestion() {
      var that = this; //进入下一道题

      that.getQuestionShowType(1);
    },

    /**
     * 显示附件信息
     */
    showFileInfo: function showFileInfo() {
      this.openFileFlag = true;
      this.openQuestionFlag = false; //        this.nowCheckQuestion = -1;

      this.$emit("changeQuestionState", {
        "openPrevFlag": this.openPrevFlag,
        "openFileFlag": this.openFileFlag,
        "openQuestionFlag": this.openQuestionFlag,
        "openScript": null,
        "openPlayTalk": null
      });
    },

    /**
     * 显示试题信息
     */
    showQuestionInfo: function showQuestionInfo() {
      var that = this;
      var quesEqType = that.questionInfo.eqType;
      this.openFileFlag = false;
      this.openPrevFlag = false;
      this.openQuestionFlag = true;
      this.newPlayerWay = true;

      if (that.questionInfo.ZD_DO_WAY == 1 && this.openQuestionFlag && this.nowCheckQuestion == -1) {
        that.$nextTick(function () {
          that.getQuestionShowType(0);
        });
      }

      this.playEqContentVolume(); //切换试卷页面的 按钮的显示状态

      this.$emit("changeQuestionState", {
        "openPrevFlag": this.openPrevFlag,
        "openFileFlag": this.openFileFlag,
        "openQuestionFlag": this.openQuestionFlag,
        "openScript": null,
        "openPlayTalk": null
      }); // 如果是阅读题 调用子题的 试题显示

      if (quesEqType == 9) {
        if (this.$refs["child_question_" + this.questionId + "_" + that.nowCheckQuestion]) {
          var oneQuestionRef = this.$refs["child_question_" + this.questionId + "_" + that.nowCheckQuestion][0];
          oneQuestionRef.showQuestionInfo();
        }
      }
    },
    changeQuestionState: function changeQuestionState(json) {
      //切换试卷页面的 按钮的显示状态
      this.$emit("changeQuestionState", json);
    },

    /**
     * 加载上一题 或者下一题
     */
    getQuestionShowType: function getQuestionShowType(indexType) {
      var that = this;

      if (indexType == 1) {
        that.nowCheckQuestion++;
      } else if (indexType == -1) {
        that.nowCheckQuestion--;
      } else if (indexType == 0) {
        that.nowCheckQuestion = 0;
      } else if (indexType == -10) {
        //直接选中最后一题
        that.nowCheckQuestion = that.questionInfo.childQuestionInfoList.length - 1;
      }

      this.showQuestionIndex(that.nowCheckQuestion); //判断试题是否有倒计时 如果有 则传递给试卷

      var limitTime = that.questionInfo.prevSet.limitTime;
      this.$emit("setCountDownInfo", 2, limitTime);
    },
    showQuestionIndex: function showQuestionIndex(nowCheckQuestion) {
      var that = this;
      that.nowCheckQuestion = nowCheckQuestion; //切换阅读题的题目内容

      this.$nextTick(function () {
        that.childQuesionContentChange();
      });
    },

    /**
     * 当阅读题切换下一题时 进行阅读题 题干内容的变更切换
     */
    childQuesionContentChange: function childQuesionContentChange() {
      var that = this; //获取当前试题的 段落 和 高亮标识 和 插入点标识

      var questionId = this.questionId; //隐藏阅读题的 段落标识 高亮标识 和插入点标识
      //根据本道题的段落 插入点 高亮标识 进行阅读题内容的显示

      $("#eqContentId_" + questionId).find("span[aType=1]").hide();
      $("#eqContentId_" + questionId).find("span[aType=2]").hide();
      $("#eqContentId_" + questionId).find("span[aType=3]").attr("style", null);
      var childQuestionInfoList = this.questionInfo.childQuestionInfoList;
      console.log("this.questionInfo===========", this.questionInfo);

      if (childQuestionInfoList && this.showType != 1) {
        // var oneQuestionRef = this.$refs["child_question_"+questionId+"_"+that.nowCheckQuestion][0];
        // var oneQuestionInfo = oneQuestionRef.questionInfo;
        // var oneDoQuestionInfo = oneQuestionRef.value;
        var oneQuestionInfo = childQuestionInfoList[that.nowCheckQuestion];
        var oneDoQuestionInfo = this.value.childStuAnswerList[that.nowCheckQuestion]; //需要选中的段落

        var sectionNum = oneQuestionInfo.sectionNum; //          console.log("oneQuestionInfo========================",oneQuestionInfo);
        //          console.log("sectionNum========================",sectionNum);

        if (sectionNum) {
          sectionNum.forEach(function (element, index) {
            $("#eqContentId_" + questionId).find("span[aType=1]:eq(" + (element * 1 - 1) + ")").show();

            if (index == 0) {
              $("#eqContentId_" + questionId).parent().animate({
                scrollTop: "0" + "px"
              }, 0);
              var t_a = $("#eqContentId_" + questionId).find("span[aType=1]:eq(" + (element * 1 - 1) + ")").offset(); //                    console.log("============================",t_a);

              $("#eqContentId_" + questionId).parent().animate({
                scrollTop: t_a.top - "170" + "px"
              }, 500);
            }
          });
        } //需要选中的高亮标识


        var heightDc = oneQuestionInfo.heightDc; //          console.log("heightDc========================",heightDc);

        if (heightDc) {
          heightDc.forEach(function (element, index) {
            $("#eqContentId_" + questionId).find("span[aType=3]:contains('" + element + "')").attr("style", "background-color: gray;");
          });
        } //需要显示插入点标识  如果试题类型为插入填空


        var eqType = oneQuestionInfo.eqType; //          console.log("eqType========================",eqType,that.nowCheckQuestion);

        if (eqType == 15) {
          var eqInsertContent = oneQuestionInfo.eqInsertContent;
          $("#eqContentId_" + questionId).find("span[aType=2]").show(); //给插入点绑定点击事件  点击时把句子插入到文本中 并且修改子题的选中值

          $("#eqContentId_" + questionId).find("span[aType=2]").each(function (i) {
            if (that.showType == 3) {
              $(this).bind("click", function () {
                $("#eqContentId_" + questionId).find("span[aType=2]").text(" - ");
                $(this).text(eqInsertContent);
                oneDoQuestionInfo.eqAnswer = i + "";
              });
            }

            if (oneDoQuestionInfo.eqAnswer && i == oneDoQuestionInfo.eqAnswer) {
              $("#eqContentId_" + questionId).find("span[aType=2]").text(" - ");
              $(this).text(eqInsertContent);
            }
          });
        }
      }
    },

    /**
     * 判断是否有 题目音频需要播放
     */
    playEqContentVolume: function playEqContentVolume() {
      //判断是否有试题题目音频播放  有的话进行播放
      var prevSet = this.questionInfo.prevSet;

      if (prevSet) {
        var eqContentVolume = prevSet.eqContentVolume;

        if (eqContentVolume && eqContentVolume.length > 0) {
          eqContentVolume[0].ifAutoPlay = 1;
          eqContentVolume[0].ifDragPlay = 2;
          this.eqContentVolumeFlag = true;
          this.questionInfo.ifHideAnswer = true;
        } //          console.log("eqContentVolume=====================",eqContentVolume);

      }
    },
    //关闭试题题目音频播放
    closeEqContentVolumeFlag: function closeEqContentVolumeFlag() {
      this.eqContentVolumeFlag = false;
      this.questionInfo.ifHideAnswer = false; // 自动点击开始录制

      var do_record = this.$refs.do_record;
      console.log("do_record=====================", do_record);

      if (do_record) {
        do_record.clickPreparatRecord();
      }
    },

    /**
     * 选择填空题 进行拖动停止时执行
     */
    onDragstop: function onDragstop(left, top, dragThat, eqOptionIndex) {
      //拖动元素返回初始位置 进行选中赋值
      dragThat.returnEle(); //判断应该放置到哪个元素下边答案框下面
      //        console.log("checkAswerIndex===========",this.checkAswerIndex,eqOptionIndex);

      if (this.showType == 3) {
        if (this.checkAswerIndex >= 0) {
          var oneQuestionInfo = this.questionInfo;
          var oneDoQuestionInfo = this.value;
          console.log("eqAnswer==============", oneDoQuestionInfo.eqAnswer[this.checkAswerIndex]);

          if (!oneDoQuestionInfo.eqAnswer[this.checkAswerIndex] && oneDoQuestionInfo.eqAnswer[this.checkAswerIndex] != 0) {
            var text = oneQuestionInfo.eqOption[eqOptionIndex * 1];
            console.log(text);
            console.log(oneDoQuestionInfo);
            this.$set(oneDoQuestionInfo.eqAnswer, this.checkAswerIndex, eqOptionIndex); // this.$set(oneDoQuestionInfo.eqAnswer1,this.checkAswerIndex,text);
            //当前的拖动框 隐藏

            $("[name='drag_" + eqOptionIndex + "']").hide();
          }
        }
      }
    },

    /**
     * 选择填空题 鼠标进入答案框时
     */
    mouseMoveDiv: function mouseMoveDiv(index) {
      //      $(event.target).css("background-color","red");
      this.checkAswerIndex = index;
    },

    /**
     * 选择填空题 鼠标离开答案框时
     */
    mouseOutDiv: function mouseOutDiv(index) {
      $(event.target).css("background-color", "");
      this.checkAswerIndex = -1;
    },

    /**
     * 选择填空题  单击取消答案选中
     */
    cancelCheckAnswer8: function cancelCheckAnswer8(answerIndex) {
      if (this.showType == 3) {
        var oneQuestionInfo = this.questionInfo;
        var oneDoQuestionInfo = this.value;
        var optionIndex = oneDoQuestionInfo.eqAnswer[answerIndex]; //当前的拖动框 隐藏

        $("[name='drag_" + optionIndex + "']").show();
        this.$set(oneDoQuestionInfo.eqAnswer, answerIndex, null);
      }
    },

    /**
     * 设置父级试题或者试卷的定时器信息
     */
    setCountDownInfo: function setCountDownInfo(type, limitTime) {
      this.$emit("setCountDownInfo", type, limitTime);
    }
  }
};